import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_left_start",
  "use": "chevron_left_start-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"chevron_left_start\"><path d=\"m8 9 5.71-5.71a.996.996 0 1 1 1.41 1.41L10.82 9l4.29 4.29a.996.996 0 1 1-1.41 1.41z\" /><path fill-rule=\"evenodd\" d=\"M4 3a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol